import { render, staticRenderFns } from "./digital-reading.vue?vue&type=template&id=356dac8f&scoped=true&"
import script from "./digital-reading.vue?vue&type=script&lang=js&"
export * from "./digital-reading.vue?vue&type=script&lang=js&"
import style0 from "./digital-reading.vue?vue&type=style&index=0&id=356dac8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356dac8f",
  null
  
)

export default component.exports